// Welcome-onboarding flag — controls whether the guided "Welcome" tour is
// shown. Stored in localStorage (per browser, as specified). The tour runs
// once on first login and can be re-launched from the Help page.

const KEY = 'bandz.welcome.seen';

/** Mark the Welcome tour as seen (completed or skipped). */
export function markWelcomeSeen(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch {
    // ignore — the tour simply re-runs next login if storage is unavailable
  }
}